import SliderSectionComponent from './slider-regular-entire';

export default SliderSectionComponent;